import React from 'react'
import icon_fotter_1 from '../../img/icon_fotter_1.png'
import icon_fotter_2 from '../../img/icon_fotter_2.png'
import icon_fotter_3 from '../../img/icon_fotter_3.png'
import icon_fotter_4 from '../../img/icon_fotter_4.png'


const S1_Fotter = () => {

  return (
<section className='S1_fotter'>
    <div className='container'>
        <div className='row'>
                <div className='col-lg-3 col-md-6 card_con'>
                    <img src={icon_fotter_1} alt='fotter img'/>
                    <h4>Worldwide Shipping</h4>  
                    <p>It elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                </div>      

                <div className='col-lg-3 col-md-6 card_con'>
                    <img src={icon_fotter_2} alt='fotter img'/>
                    <h4>Best Quality</h4>  
                    <p>It elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                      

                </div>  

                <div className='col-lg-3 col-md-6 card_con'>
                    <img src={icon_fotter_3} alt='fotter img'/>
                    <h4>Best Offers</h4>  
                    <p>It elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                      

                </div>  

                <div className='col-lg-3 col-md-6 card_con'>
                    <img src={icon_fotter_4} alt='fotter img'/>
                    <h4>Secure Payments</h4>  
                    <p>It elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                      

                </div>  
                  

        </div>
        </div> 
</section>
  )
}

export default S1_Fotter